export default __webpack_public_path__ + "static/media/projectpage.46422f6f.jpg";